import * as React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'

import { IAuthState } from 'containers/Auth'
import AuthContext, { IAuthContext } from 'context/AuthContext'
import { ICompany } from 'interfaces/ICompany'
import { PATHS } from 'paths'

class Dashboard extends React.Component<
  RouteComponentProps<{}> & {
    companies: IAuthState['companies']
    clients: IAuthContext['clients']
    company: IAuthState['company']
    setCompany: IAuthContext['setCompany']
  }
> {
  public sortClients = (a: string, b: string) =>
    this.props.clients[a].name > this.props.clients[b].name ? 1 : -1

  public company = (id: string): ICompany => {
    return this.props.companies[id] || {}
  }

  public render() {
    const { props, company } = this

    if (!props.company) {
      if (Object.keys(props.companies).length === 0) {
        return (
          <Link className="button" to={PATHS.company.create}>
            <span>Skapa&nbsp;företag</span>
          </Link>
        )
      }

      return (
        <ul>
          {Object.keys(props.companies).map(id => (
            <li key={id}>
              <button onClick={() => props.setCompany && props.setCompany(id)}>
                {company(id).name}
              </button>
            </li>
          ))}
        </ul>
      )
    }

    return (
      <div>
        <h2>Ny faktura</h2>
        <select
          name="client"
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            this.props.history.push(
              `/invoices/create?clientKey=${e.currentTarget.value}`
            )
          }
          defaultValue=""
        >
          <option disabled value="">
            Ny faktura
          </option>
          {Object.keys(props.clients)
            .sort(this.sortClients)
            .map(id => (
              <option value={id} key={id}>
                {props.clients[id] && props.clients[id].name}
                {' - '}
                {props.clients[id] && props.clients[id].reference}
              </option>
            ))}
        </select>
      </div>
    )
  }
}

export default (props: RouteComponentProps<{}>) => (
  <AuthContext.Consumer>
    {({ companies, company, clients, setCompany }) => (
      <Dashboard
        {...props}
        companies={companies}
        company={company}
        clients={clients}
        setCompany={setCompany}
      />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.tsx